const USER_CANCELING_ONBOARDING_CUSTOM_ACTION =
  'S0005: El usuario ha decidido cancelar el onboarding desde el modal de abandono, llamando al /cancel';

export { USER_CANCELING_ONBOARDING_CUSTOM_ACTION };
